import { Alert } from 'components/Display/Alert/Alert';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { getScrollableParent } from 'support/helpers/scroll/scroll';

type ValidationErrorsType = {
  errors: Array<string>;
  className?: string;
};

export function ValidationErrors({ errors, className }: ValidationErrorsType) {
  const { t } = useTranslation();
  const hasErrors = errors.length > 0;
  const ref = useRef(null);

  useEffect(() => {
    if (hasErrors) {
      getScrollableParent(ref.current)?.scrollTo(0, 0);
    }
  }, [hasErrors]);

  if (!hasErrors) {
    return null;
  }

  return (
    <Alert severity="error" title={t('auth:errors.heading')} ref={ref} className={className}>
      <ul className="list-disc space-y-1 pl-5">
        {errors.map((error: string) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    </Alert>
  );
}
